{
  "_format": "hh-sol-artifact-1",
  "contractName": "PoolControllerFlex",
  "sourceName": "contracts/controllers/PoolControllerFlex.sol",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "pool",
          "type": "address"
        }
      ],
      "name": "DisruptionOrDefault",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "enum IPoolLifeCycleStateFlex",
          "name": "state",
          "type": "uint8"
        }
      ],
      "name": "LifeCycleStateTransition",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [],
      "name": "PoolSettingsUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "pool",
          "type": "address"
        }
      ],
      "name": "Rescheduled",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "activatePool",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "admin",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "borrowerManagerAddr",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "borrowerWalletAddr",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "closeOfDepositTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "closeOfWithdrawTime",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint32",
          "name": "sourceChainId",
          "type": "uint32"
        },
        {
          "internalType": "address",
          "name": "sourcePoolAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferApproveDestination",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint32",
          "name": "destinationChainId",
          "type": "uint32"
        },
        {
          "internalType": "address",
          "name": "destinationPoolAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "sourceWalletAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferApproveSource",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "destinationWalletAddr",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "crossChainTransferMintDestination",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "dailyOriginationFeeRate",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "disruptionOrDefault",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "pool_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "serviceConfiguration_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "admin_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "liquidityAsset_",
          "type": "address"
        },
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "maxCapacity",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "borrowerManagerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerWalletAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "closeOfDepositTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfWithdrawTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyOriginationFeeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDays",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolConfigurableSettingsFlex",
          "name": "poolSettings_",
          "type": "tuple"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "originationFee",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pool",
      "outputs": [
        {
          "internalType": "contract IPoolFlex",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "serviceConfiguration",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "settings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "maxCapacity",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "borrowerManagerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerWalletAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "closeOfDepositTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfWithdrawTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyOriginationFeeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDays",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolConfigurableSettingsFlex",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "state",
      "outputs": [
        {
          "internalType": "enum IPoolLifeCycleStateFlex",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferInDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "transferOutDays",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newAdmin_",
          "type": "address"
        }
      ],
      "name": "updatePoolAdmin",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "maxCapacity",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "borrowerManagerAddr",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "borrowerWalletAddr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "closeOfDepositTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "closeOfWithdrawTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "originationFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "dailyOriginationFeeRate",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferInDays",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "transferOutDays",
              "type": "uint256"
            }
          ],
          "internalType": "struct IPoolConfigurableSettingsFlex",
          "name": "poolSettings_",
          "type": "tuple"
        }
      ],
      "name": "updatePoolSettings",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
